import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import {
  IEventoGenerico,
  IFilter,
  IModeloDispositivo,
  IPopulate,
  IQueryParam,
  ITratamientoEvento,
} from 'modelos/src';
import { Subscription } from 'rxjs';
import { IColumnas } from '../../../../auxiliares/tabla/tabla.component';
import { IFiltroTabla } from '../../../../auxiliares/tabla/filtro/filtro.component';
import {
  HelperService,
  Modulo,
} from '../../../../auxiliares/servicios/helper.service';

import { MatDialog } from '@angular/material/dialog';

import { ActivatedRoute, Router } from '@angular/router';
import { Lista2Service } from '../../../../auxiliares/servicios/lista2.service';
import { EventosGenericosHelperService } from '../helper';
import { DetallesEventoGenericoComponent } from '../detalles-evento-generico/detalles-evento-generico.component';
import { TratamientoEventosService } from '../../../../auxiliares/servicios/http/tratamientos-eventos.service';
import { ModeloDispositivoSelectorCacheService } from '../../../../componentes/selectores/modelo-dispositivo-selector/modelo-dispositivo-selector-cache.service';
import { ClienteJerarquiaService } from '../../../../auxiliares/servicios/cliente-jerarquia.service';

@Component({
  selector: 'app-eventos-genericos-historico',
  templateUrl: './eventos-genericos-historico.component.html',
  styleUrl: './eventos-genericos-historico.component.scss',
  standalone: false,
})
export class EventosGenericosHistoricoComponent implements OnInit, OnDestroy {
  private clienteJerarquia = inject(ClienteJerarquiaService);
  private lista2Service = inject(Lista2Service);
  helper = inject(HelperService);
  dialog = inject(MatDialog);
  private navigator = inject(Router);
  private route = inject(ActivatedRoute);
  private eventosHelper = inject(EventosGenericosHelperService);
  private tratamientosService = inject(TratamientoEventosService);
  private modeloCache = inject(ModeloDispositivoSelectorCacheService);

  /** idEvento → nombres de los usuarios que lo trataron (columna Atendido por) */
  private atendidoPorEvento = new Map<string, string>();
  private epocaListado = 0;

  @Input() id?: string;
  // Cuando se conoce de antemano el único tipoEvento posible (ej. la
  // alarma solo puede tener 'Evento Alarma'), lo fija y oculta el selector
  // en vez de dejarlo elegir un tipo que nunca varía.
  @Input() tipoEventoFijo?: string;
  public listando = false;
  //// Tabla nueva
  public name = EventosGenericosHistoricoComponent.name;
  public eventosHistorico: IEventoGenerico[] = [];
  public eventosHistorico$?: Subscription;
  public totalCount = 0;
  public columnas?: IColumnas<IEventoGenerico>[];
  // Filtros Tabla
  public cliente: IFiltroTabla = {
    filter: {
      field: 'idCliente',
    },
    label: 'Cliente',
    tipo: 'cliente-selector',
  };
  // Cliente en cuya jerarquía cuelga la entidad: el cliente elegido y toda su
  // descendencia.
  public ancestro: IFiltroTabla = {
    filter: {
      field: 'idsAncestros',
      incluirPropio: true,
    },
    label: 'En la jerarquía de',
    tipo: 'cliente-selector',
  };
  private entidad: IFiltroTabla = {
    filter: {
      field: 'idEntidad',
    },
    label: 'Entidad',
    tipo: 'entidad-eventos-selector',
  };
  private fecha: IFiltroTabla = {
    filter: {
      field: 'fechaCreacion',
    },
    label: 'Fecha',
    tipo: 'dateRange',
  };
  private testGRPS: IFiltroTabla = {
    // Antes 'Si' usaba value: [], que Mongo rechaza ($and no puede recibir
    // un array vacío: "$and/$or/$nor must be a nonempty array") y además no
    // filtraba nada. Ahora 'Si' muestra solo los eventos test.
    elementos: [
      { label: 'Sí', value: [{ 'valores.tiposEvento': { $in: ['Test'] } }] },
      { label: 'No', value: [{ 'valores.tiposEvento': { $nin: ['Test'] } }] },
    ],
    filter: {
      field: '$and',
    },
    label: '¿Ver eventos Test?',
    tipo: 'select',
    selectLabel: 'label',
    selectValue: 'value',
  };
  // Opciones del filtro Tipo de Evento con el/los módulo(s) que las habilitan.
  // Espejo de agregarFiltroModulos del backend. Gateway/BotonBLE = infra
  // luminaria. Tracker aplica a Activos/Vehículos/Colectivos. Nivel 0 ve todos.
  private tipoEventoOpciones: {
    label: string;
    value: string;
    modulos: Modulo[];
  }[] = [
    {
      label: 'Evento Colectivo',
      value: 'Evento Colectivo',
      modulos: ['Colectivos'],
    },
    { label: 'Evento Activo', value: 'Evento Activo', modulos: ['Activos'] },
    {
      label: 'Evento Tracker',
      value: 'Evento Tracker',
      modulos: ['Activos', 'Vehículos', 'Colectivos'],
    },
    {
      label: 'Evento Vehículo',
      value: 'Evento Vehiculo',
      modulos: ['Vehículos'],
    },
    { label: 'Evento Alarma', value: 'Evento Alarma', modulos: ['Alarmas'] },
    {
      label: 'Evento Luminaria',
      value: 'Evento Luminaria',
      modulos: ['Luminarias'],
    },
    {
      label: 'Evento Gateway',
      value: 'Evento Gateway',
      modulos: ['Luminarias'],
    },
    {
      label: 'Evento BotonBLE',
      value: 'Evento BotonBLE',
      modulos: ['Luminarias'],
    },
    { label: 'Evento Sirena', value: 'Evento Sirena', modulos: ['Sirenas'] },
  ];
  private tipoEvento: IFiltroTabla = {
    elementos: [],
    filter: {
      field: 'tipoEvento',
    },
    label: 'Tipo de evento',
    tipo: 'select',
    selectLabel: 'label',
    selectValue: 'value',
  };

  public filtros: IFiltroTabla[] = [
    this.tipoEvento,
    this.fecha,
    this.entidad,
    this.cliente,
    this.ancestro,
  ];

  // FILTROS

  public populate: IPopulate[] = [
    {
      path: 'alarma',
      select: 'nombre comunicadores idModelo',
      populate: [
        {
          path: 'modelo',
          select: 'marca modelo',
        },
      ],
    },
    {
      path: 'activo',
      select: 'identificacion categoria',
    },
    {
      path: 'tracker',
      select: 'identificacion',
    },
    {
      path: 'cliente',
      select: 'nombre',
    },
    {
      path: 'luminaria',
      select: 'identificacion',
    },
    {
      path: 'gateway',
      select: 'nombre nombreChirpstack',
    },
    {
      path: 'botonBluetooth',
      select: 'mac',
    },
    {
      path: 'sirena',
      select: 'chipId',
    },
  ];
  public query: IQueryParam = {
    populate: JSON.stringify(this.populate),
    sort: '-fechaCreacion',
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    includeChildren: true,
    childrenLevel: 0,
    // excludeTotalCount: true,
  };

  // Devuelve un populate reducido cuando se filtra por un tipoEvento específico
  private getPopulateForTipoEvento(tipoEvento?: string): IPopulate[] {
    const clientePopulate: IPopulate = {
      path: 'cliente',
      select: 'nombre',
    };
    switch (tipoEvento) {
      case 'Evento Alarma':
        return [
          this.populate.find((p) => p.path === 'alarma')!,
          clientePopulate,
        ];
      case 'Evento Activo':
      case 'Evento Vehiculo':
      case 'Evento Colectivo':
        return [
          { path: 'activo', select: 'identificacion categoria' },
          { path: 'tracker', select: 'identificacion' },
          clientePopulate,
        ];
      case 'Evento Tracker':
        return [{ path: 'tracker', select: 'identificacion' }, clientePopulate];
      case 'Evento Luminaria':
        return [
          { path: 'luminaria', select: 'identificacion' },
          clientePopulate,
        ];
      case 'Evento Gateway':
        return [
          { path: 'gateway', select: 'nombre nombreChirpstack' },
          clientePopulate,
        ];
      case 'Evento BotonBLE':
        return [{ path: 'botonBluetooth', select: 'mac' }, clientePopulate];
      case 'Evento Sirena':
        return [{ path: 'sirena', select: 'chipId' }, clientePopulate];
      default:
        return this.populate;
    }
  }

  public async listar(): Promise<void> {
    this.listando = true;
    // Histórico = eventos 'Evento' finalizados. filtrador + estado fijos permiten
    // usar el índice {filtrador, estado, fechaCreacion} con sort por índice
    // (sin SORT en memoria). Preserva los filtros del usuario.
    const filterObj: Record<string, unknown> = HelperService.stringToObject(
      this.query.filter,
    );
    (filterObj as any).filtrador = 'Evento';
    (filterObj as any).estado = 'Finalizada';
    if (this.id) {
      (filterObj as any).idEntidad = this.id;
    }
    if (this.tipoEventoFijo) {
      (filterObj as any).tipoEvento = this.tipoEventoFijo;
    }
    // Populate optimizado: si se filtra por un tipoEvento específico,
    // solo populamos la entidad relevante (evita joins innecesarios)
    const populateToUse = this.getPopulateForTipoEvento(
      filterObj['tipoEvento'] as string | undefined,
    );
    const queryToSend: IQueryParam = {
      ...this.query,
      populate: JSON.stringify(populateToUse),
      filter: JSON.stringify(filterObj),
      excludeTotalCount: true, // colección gigante: evita timeout en count
    };

    this.eventosHistorico$?.unsubscribe();
    this.eventosHistorico$ = this.lista2Service
      .eventosGenericos(queryToSend, 30)
      .subscribe((data) => {
        const limit = +(this.query.limit || 10);
        const page = +(this.query.page || 0);
        const datos = data.datos || [];
        // Estimación de paginación sin count real
        this.totalCount =
          datos.length === limit
            ? (page + 1) * limit + 1
            : page * limit + datos.length;
        this.eventosHistorico = datos;
        this.listando = false;
        // "Atendido por" sale de una SEGUNDA query (tratamientos).
        void this.cargarAtendidoPor(datos, ++this.epocaListado);
      });
  }

  /**
   * Columna "Atendido por": se deriva de los tratamientos (participó = creó un
   * tratamiento). Una sola query batch por página de eventos, resuelta DESPUÉS
   * de pintar la tabla. El mapa se arma aparte y recién se publica al final:
   * vaciarlo al arrancar borraba la columna de la página ya visible mientras
   * la query estaba en vuelo.
   */
  private async cargarAtendidoPor(
    eventos: IEventoGenerico[],
    epoca: number,
  ): Promise<void> {
    const ids = (eventos || []).map((e) => e._id).filter(Boolean);
    if (!ids.length) {
      if (epoca === this.epocaListado) this.atendidoPorEvento = new Map();
      return;
    }
    try {
      const filter: IFilter<ITratamientoEvento> = {
        idsEventos: { $in: ids },
        estado: { $ne: 'Sin Tratamiento' },
      } as any;
      const query: IQueryParam = {
        filter: JSON.stringify(filter),
        select: 'idsEventos idUsuario',
        populate: JSON.stringify([
          {
            path: 'usuario',
            select: 'usuario datosPersonales.nombre',
          },
        ]),
        limit: 2000,
        excludeTotalCount: true,
        includeChildren: true,
      };
      const res = await this.tratamientosService.getFiltered(query);
      const idsPagina = new Set(ids);
      const usuariosPorEvento = new Map<string, Map<string, string>>();
      for (const tratamiento of res?.datos || []) {
        const usuario = tratamiento.usuario;
        const nombre = usuario?.datosPersonales?.nombre || usuario?.usuario;
        if (!nombre || !tratamiento.idUsuario) continue;
        for (const idEvento of tratamiento.idsEventos || []) {
          if (!idsPagina.has(idEvento)) continue;
          if (!usuariosPorEvento.has(idEvento)) {
            usuariosPorEvento.set(idEvento, new Map());
          }
          usuariosPorEvento.get(idEvento)!.set(tratamiento.idUsuario, nombre);
        }
      }
      const mapa = new Map<string, string>();
      for (const [idEvento, usuarios] of usuariosPorEvento) {
        mapa.set(idEvento, [...usuarios.values()].join(', '));
      }
      if (epoca !== this.epocaListado) return;
      this.atendidoPorEvento = mapa;
      this.eventosHistorico = [...this.eventosHistorico];
    } catch (error) {
      console.error('Error cargando atendido por', error);
    }
  }
  // Acciones
  public verDetalles(evento: IEventoGenerico): void {
    this.dialog.open(DetallesEventoGenericoComponent, {
      data: { evento },
      width: '900px',
      maxWidth: '95vw',
    });
  }

  public async detalles(evento: IEventoGenerico) {
    // Adapted from EventosGenericosVivosComponent
    if (evento?.alarma?._id) {
      this.navigator.navigate([
        `main/alarmas/alarmasDomiciliarias/detallesAlarma/${evento.alarma._id}`,
      ]);
      return;
    }
    if (evento?.luminaria?._id) {
      this.navigator.navigate([
        `main/luminarias/luminarias/detalles/${evento.luminaria._id}`,
      ]);
      return;
    }
    if (evento?.gateway?._id) {
      this.navigator.navigate([
        `main/administracion/gateways/detalles/${evento.gateway._id}`,
      ]);
      return;
    }
    if (evento?.activo?._id) {
      if (evento.activo.vehiculo) {
        this.navigator.navigate([
          `main/vehiculos/vehiculos/detalles/${evento.activo._id}`,
        ]);
        return;
      } else {
        this.navigator.navigate([
          `main/activos/activos/detalles/${evento.activo._id}`,
        ]);
        return;
      }
    }
    if (evento.sirena?._id) {
      this.navigator.navigate([
        `main/sirenas/sirenas/detalles/${evento.sirena._id}`,
      ]);
      return;
    }
  }

  // Tabla

  private setColumnas() {
    const columnas: IColumnas<IEventoGenerico>[] = [
      // Fecha
      {
        header: {
          label: 'Fecha',
          sortable: true,
          sort: 'fechaCreacion',
        },
        row: {
          fecha: (dato) => dato.fechaCreacion,
          hace: true,
          noData: 'Sin fecha',
        },
      },
      // Categoría: badge del color de la categoría con el nombre adentro
      {
        header: {
          label: 'Categoría',
        },
        row: {
          html: (dato) => this.eventosHelper.categoriaHtml(dato),
          noData: 'Sin categoría',
        },
      },
      // Nombre evento
      {
        header: {
          label: 'Evento',
        },
        row: {
          parse(dato) {
            return dato.valores?.titulo;
          },
          noData: 'Sin título',
        },
      },
      // Detalles
      {
        header: {
          label: 'Detalles',
        },
        row: {
          parse(dato) {
            return dato.valores?.['mensaje'];
          },
          noData: 'Sin detalles',
        },
      },
      // Activo / Alarma / Entidad
      {
        header: {
          label: 'Entidad',
        },
        row: {
          html: (dato) => this.eventosHelper.obtenerEntidad(dato),
          noData: 'Sin asignar',
        },
      },
      // Dispositivo
      {
        header: {
          label: 'Dispositivo',
        },
        row: {
          parse: (dato) => {
            if (dato.tracker) {
              return dato.tracker?.identificacion || '';
            }
            if (dato.gateway) {
              return (
                dato.gateway?.nombre || dato.gateway?.nombreChirpstack || ''
              );
            }
            if (dato.luminaria) {
              return dato.luminaria?.identificacion || '';
            }
            if (dato.alarma) {
              let text = '';
              const marcasModelos = (dato.alarma.comunicadores ?? [])
                .map((c) =>
                  this.modeloCache.getModeloPorIdSync(c.idComunicador),
                )
                .filter((m): m is IModeloDispositivo => !!m)
                .map((m) => `${m.marca} ${m.modelo}`);
              if (marcasModelos.length) {
                text = marcasModelos.join(', ');
              }
              const alarma = dato.alarma.modelo;
              if (alarma) {
                text += ` - ${alarma.marca} ${alarma.modelo}`;
              }
              if (text.length >= 50) {
                text = text.slice(0, 50);
                text += '…';
              }
              return text;
            }
            if (dato.sirena) {
              return dato.sirena?.chipId || '';
            }
            return '';
          },
          noData: 'Sin identificación',
        },
      },
      // Usuario que GENERÓ el evento (no confundir con "Atendido por", que es
      // el operador que lo trató)
      {
        header: {
          label: 'Usuario',
        },
        row: {
          parse: (dato) =>
            (dato.valores as { usuario?: string } | undefined)?.usuario || '',
          noData: 'Sin usuario',
        },
      },
      // Atendido por (derivado de los tratamientos del evento)
      {
        header: {
          label: 'Atendido por',
        },
        row: {
          parse: (dato) => this.atendidoPorEvento.get(dato._id as any) || '',
          noData: 'Sin atender',
        },
      },
    ];

    // Cliente
    if (HelperService.getTipoCliente() !== 'Final') {
      {
        columnas.push({
          header: {
            label: 'Cliente',
          },
          row: {
            html: (dato) => this.clienteJerarquia.htmlNombre(dato.cliente),
            tooltip: (dato) =>
              this.clienteJerarquia.tooltipJerarquia(dato.cliente),
          },
        });
      }
    }

    // Acciones
    columnas.push({
      header: {
        label: 'Acciones',
      },
      row: {
        acciones: [
          {
            tipo: 'material',
            color: 'primary',
            icon: 'visibility',
            tooltip: 'Ver detalle',
            click: (dato) => this.verDetalles(dato),
          },
        ],
      },
    });

    this.columnas = columnas;
  }

  // Hooks

  async ngOnInit() {
    // Warm-up: fila "Dispositivo" resuelve marca/modelo de comunicadores[]
    // por id de forma síncrona (getModeloPorIdSync) — necesita el cache tibio.
    this.modeloCache.getModelos().subscribe();
    // Opciones de Tipo de Evento solo de los módulos que tiene el usuario.
    this.tipoEvento.elementos = this.tipoEventoOpciones
      .filter((o) => this.helper.tieneModulo(...o.modulos))
      .map((o) => ({ label: o.label, value: o.value }));
    // "Ver eventos Test?" solo aplica a alarmas → mostrarlo solo con ese módulo.
    if (this.helper.tieneModulo('Alarmas')) {
      this.filtros.push(this.testGRPS);
    }
    // Con entidad fija (histórico embebido en detalles), el filtro de
    // entidad sobra, y el de cliente también: la entidad ya pertenece a un
    // único cliente, filtrar por cliente no puede acotar más.
    if (this.id) {
      this.filtros = this.filtros.filter(
        (f) => f !== this.entidad && f !== this.cliente,
      );
    }
    // Con tipoEvento fijo (ej. alarma: siempre 'Evento Alarma'), el
    // selector sobra — no hay nada para elegir.
    if (this.tipoEventoFijo) {
      this.filtros = this.filtros.filter((f) => f !== this.tipoEvento);
    }
    this.setColumnas();
    await this.listar();
  }

  async ngOnDestroy() {
    this.eventosHistorico$?.unsubscribe();
  }
}
